import { Injectable } from '@angular/core';
import { Router } from "@angular/router";

import { ContactEndpoint } from './contact-endpoint.service';
import { ContactRequest } from '../models/contact/contact.model';

@Injectable()

export class ContactService {
  constructor(private router: Router, private contactEndpoint: ContactEndpoint) {

  }  

  sendEmail(request: ContactRequest) {
    return this.contactEndpoint.sendEmail(request);
  }
}
